import { Reveal } from "@/components/shared/Reveal";

const PROMO_VIDEO_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_landing-hub-908/artifacts/ae115ae5aa91b5c7_dbf5c780412e4dc2aeb613ea6b11776f_relayrigs_140_new.mp4";

export const PromoVideo = () => (
  <section data-testid="promo-video-section" className="bg-rr-navy pt-16 md:pt-20 pb-2 relative overflow-hidden">
    <div className="grain-overlay opacity-30" />
    <div className="max-w-4xl mx-auto px-5 md:px-8 relative">
      <Reveal className="text-center mb-8">
        <span className="text-rr-orangeLight text-xs font-bold tracking-[0.2em] uppercase">See RelayRigs In Action</span>
        <h2 className="font-heading text-2xl md:text-3xl font-black text-white mt-2">Watch: RelayRigs Is Coming</h2>
      </Reveal>
      <Reveal delay={0.1} className="relative rounded-2xl overflow-hidden border border-white/10 aspect-video bg-black shadow-2xl">
        <video
          data-testid="promo-video-player"
          src={PROMO_VIDEO_URL}
          controls
          playsInline
          preload="metadata"
          className="w-full h-full"
        />
      </Reveal>
    </div>
  </section>
);
